/* PKF Sport — Header : auto-hide au scroll (descend = caché, remonte = visible)
   + état "scrolled" (glass plus dense dès qu'on quitte le sommet). */
(function () {
  if (typeof window === 'undefined') return;
  if (window.__pkfHdr) return;
  window.__pkfHdr = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function findHeader() {
    return (
      document.querySelector('header.shopify-section.header-section') ||
      document.querySelector('header.shopify-section-group-header-group') ||
      document.querySelector('.shopify-section-group-header-group') ||
      document.querySelector('.header-section')
    );
  }

  function attach(header) {
    var lastY = window.pageYOffset || document.documentElement.scrollTop || 0;
    var ticking = false;
    var THRESHOLD = 8;
    var SHOW_AT_TOP = 60;

    function update() {
      var y = window.pageYOffset || document.documentElement.scrollTop || 0;

      if (y > 24) header.classList.add('pkf-header--scrolled');
      else header.classList.remove('pkf-header--scrolled');

      if (!reduce) {
        var delta = y - lastY;
        if (Math.abs(delta) >= THRESHOLD) {
          if (y <= SHOW_AT_TOP) header.classList.remove('pkf-header--hidden');
          else if (delta > 0) header.classList.add('pkf-header--hidden');
          else header.classList.remove('pkf-header--hidden');
          lastY = y;
        }
      }
      ticking = false;
    }

    window.addEventListener('scroll', function () {
      if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
    }, { passive: true });

    update();
  }

  function init() {
    var h = findHeader();
    if (h) { attach(h); return; }
    var tries = 0;
    var t = setInterval(function () {
      var h2 = findHeader();
      if (h2) { clearInterval(t); attach(h2); }
      else if (++tries > 20) { clearInterval(t); }
    }, 100);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
